import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    btnNewPass: {
        height: "64px",
        width: "100%",
        borderColor: "black!important",
        color: "black!important",
        display: "flex",
        justifyItems: "flex-start",
    },

    pageWrapper: {
        padding: "0px",
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
    },

    h4: {
        marginBottom: "0.5rem",
        fontSize: "18px",
    },

    textMargin: {
        marginTop: "1rem",
        marginBottom: "1rem",
    },
}));
